module.exports = __webpack_public_path__ + "img/RO.a994210a.png";